// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suppressed-mention-fragment {
  display: contents;
}

.suppressed-mention {
  position: relative;
  display: inline;
  cursor: help;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
}

.suppressed-mention:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--primary-color, #2563eb);
  outline-offset: 2px;
}

.suppressed-mention-tooltip {
  position: fixed;
  z-index: 4000;
  width: max-content;
  max-width: min(240px, 70vw);
  border-radius: 6px;
  padding: 5px 8px;
  background: var(--tooltip-background, #111827);
  color: var(--tooltip-color, #fff);
  box-shadow: 0 4px 12px rgb(0 0 0 / 20%);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.25;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 120ms ease,
    visibility 120ms ease;
}

.suppressed-mention-tooltip-above {
  transform: translate(-50%, -100%);
}

.suppressed-mention-tooltip-below {
  transform: translateX(-50%);
}

.suppressed-mention-tooltip-visible {
  opacity: 1;
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/suppressed-mention.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB;;yBAEuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB","sourcesContent":[".suppressed-mention-fragment {\n  display: contents;\n}\n\n.suppressed-mention {\n  position: relative;\n  display: inline;\n  cursor: help;\n  text-decoration-line: underline;\n  text-decoration-style: dashed;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 3px;\n}\n\n.suppressed-mention:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--primary-color, #2563eb);\n  outline-offset: 2px;\n}\n\n.suppressed-mention-tooltip {\n  position: fixed;\n  z-index: 4000;\n  width: max-content;\n  max-width: min(240px, 70vw);\n  border-radius: 6px;\n  padding: 5px 8px;\n  background: var(--tooltip-background, #111827);\n  color: var(--tooltip-color, #fff);\n  box-shadow: 0 4px 12px rgb(0 0 0 / 20%);\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1.25;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 120ms ease,\n    visibility 120ms ease;\n}\n\n.suppressed-mention-tooltip-above {\n  transform: translate(-50%, -100%);\n}\n\n.suppressed-mention-tooltip-below {\n  transform: translateX(-50%);\n}\n\n.suppressed-mention-tooltip-visible {\n  opacity: 1;\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
